var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 8.59375V6.79688C10.0313 6.32031 10.2206 5.86327 10.5575 5.52629C10.8945 5.18931 11.3516 5 11.8281 5H19.0156C19.4922 5 19.9492 5.18931 20.2862 5.52629C20.6232 5.86327 20.8125 6.32031 20.8125 6.79688V17.5781C20.8125 18.0547 20.6232 18.5117 20.2862 18.8487C19.9492 19.1857 19.4922 19.375 19.0156 19.375H12.1875C11.1952 19.375 10.0312 18.5704 10.0312 17.5781V15.7812",
    stroke: "#341439",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 15.7812L17.9375 12.1875L14.3438 8.59375M5 12.1875H17.2188",
    stroke: "#341439",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.383f7670326daf944425bf931d9c0a02.svg";
export { ForwardRef as ReactComponent };